export const queryKeys = {
  store: {
    all: ['store'] as const,
    byDomain: (domain: string) => [...queryKeys.store.all, 'byDomain', domain] as const,
  },
  subscriptions: {
    all: ['subscriptions'] as const,
    // Under all, but the pause invalidates the list with exact: true, so options are only
    // dropped by an explicit pauseOptions invalidation.
    pauseOptions: (id: string) => [...queryKeys.subscriptions.all, 'pauseOptions', id] as const,
  },
  // Its own root: a pause refreshes subscriptions but shouldn't trigger another Whop read.
  paymentMethod: {
    all: ['paymentMethod'] as const,
    bySubscription: (id: string) => [...queryKeys.paymentMethod.all, id] as const,
  },
  orders: {
    all: ['orders'] as const,
    list: (page: number, pageSize: number) =>
      [...queryKeys.orders.all, 'list', { page, pageSize }] as const,
    detail: (id: string) => [...queryKeys.orders.all, 'detail', id] as const,
  },
  account: {
    all: ['account'] as const,
  },
} as const;
